import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/entity-pages/subpage/about-us/src/components/documents/empty-state-icon.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')